import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AppContext } from 'src/app/shared/services/app.context';
import {URL_PAGE} from "../../enums/url.pages.enum";

export const RechercheExpeditionGuard = () => {
  const appContext: AppContext = inject(AppContext);
  const router: Router = inject(Router);

  if(appContext.currentUserHasRechercheConsultationRole()) {
    return true;
  }

  return router.navigate([URL_PAGE.HOME]);
}
